import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./index.css";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import reportWebVitals from "./reportWebVitals";

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration. This is public information
// and is safe to be exposed in the client-side code. It merely
// identifies your app to the Firebase servers.
const firebaseConfig = {
  apiKey: "AIzaSyDMdwciTiS7TsBd2qEAwtNkBb8FSvlETKM",
  authDomain: "replikers-fullstack.firebaseapp.com",
  projectId: "replikers-fullstack",
  storageBucket: "replikers-fullstack.firebasestorage.app",
  messagingSenderId: "492009759187",
  appId: "1:492009759187:web:a0f79fd8c9384768568f26",
  measurementId: "G-NY7W8SNL26",
};

// Initialize Firebase
initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
